import MockAdapter from "axios-mock-adapter";
import API_PATH from "../apiPath";

// mockデータの読み込み
import getHeaderFooter from "./data/getHeaderFooter.json";
import postTopPage from "./data/postTopPage.json";

function checkRequestUrl(path = "") {
  // ":"から始まる単語構成文字(a-zA-Z_-^9)を"/"を含まない文字列を許容するように置換する
  path =
    typeof path === "string"
      ? new RegExp(path.replace(/:\w+/g, "[^/]+"))
      : path;
  return path;
}

export default {
  checkRequestUrl,
  run: (client) => {
    const mock = new MockAdapter(client, { delayResponse: 1000 });
    // モックデータの設定
    // フッターデータ取得
    mock.onGet(API_PATH.getHeaderFooter).reply(200, getHeaderFooter);
    // TOPお知らせ取得
    mock.onGet(API_PATH.postTopPage).reply(200, postTopPage);
  },
};
